// extracted by mini-css-extract-plugin
export default {"content":"AboutMctag_content__t1Yvf","h2":"AboutMctag_h2__Xhkit","text":"AboutMctag_text__Dl0Vy","link":"AboutMctag_link__emLuk"};